/** 水深図モチーフの配色。意味と色を 1 対 1 に固定する。 */
export const PALETTE = {
  /** 水深による地の色。沖（深い）→ 浜（浅い）で補間する。 */
  deep: 0x04212c,
  mid: 0x0a4050,
  shallow: 0x1c8b84,
  shore: 0x3ec2a8,
  sand: 0xe0c285,
  sandDark: 0xc2a05e,

  /** 乗るべきもの。 */
  swell: 0x3fd6c0,
  /** 押し戻すもの。白波と離岸流。 */
  hazard: 0xff7a52,
  foam: 0xeaf6f2,

  ink: 0xe7f1ee,
  inkDim: 0x9fb9bd,
  inkFaint: 0x557781,

  shell: 0xcfe7e2,
  pearl: 0xfff3d0,
  coin: 0xe0c285,
  relic: 0xff9ecb,

  ghost: 0x9fb9bd,

  /** 遠景。常に画面上端に見えている「帰るべき場所」。 */
  skyHigh: 0x1d5f74,
  skyLow: 0xf0b98a,
  sun: 0xffe2b0,
  hill: 0x123642,
  hillFar: 0x1b4a58,
  palm: 0x0d2b33,
  building: 0x2a5c68,
  buildingLit: 0xffd9a0,

  /** 距離ブイ。50 m ごとに海面へ置く。 */
  buoy: 0xff8a4c,
  buoyPale: 0xfff0e2,

  /**
   * プレイヤーのアオウミガメ。
   * ティールの海に対していちばん見分けがつくのは暖色なので、
   * 甲羅は琥珀寄りの砂色にしてある（実際のアオウミガメもオリーブ〜黄褐色）。
   */
  shellBack: 0xd8a961,
  shellBackLight: 0xf2d6a2,
  shellBackDark: 0x8f6730,
  turtleSkin: 0x74ab90,
  turtleSkinDark: 0x3f6b57,

  /** チュートリアルの合図。教える色は他のどの意味とも被らせない。 */
  hint: 0xffe9a8,
} as const;

/** 2 色を線形補間する。背景の水深グラデーションに使う。 */
export function lerpColor(a: number, b: number, t: number): number {
  const clamped = Math.max(0, Math.min(1, t));
  const ar = (a >> 16) & 0xff;
  const ag = (a >> 8) & 0xff;
  const ab = a & 0xff;
  const br = (b >> 16) & 0xff;
  const bg = (b >> 8) & 0xff;
  const bb = b & 0xff;
  const r = Math.round(ar + (br - ar) * clamped);
  const g = Math.round(ag + (bg - ag) * clamped);
  const bl = Math.round(ab + (bb - ab) * clamped);
  return (r << 16) | (g << 8) | bl;
}

export const MONO = 'ui-monospace, SFMono-Regular, Menlo, "DejaVu Sans Mono", monospace';
export const GOTHIC =
  '"Hiragino Sans", "Hiragino Kaku Gothic ProN", "Yu Gothic", "Noto Sans JP", sans-serif';

export function hex(color: number): string {
  return '#' + color.toString(16).padStart(6, '0');
}
